export const whatsappTemplateParser = apiTemplate => {
  const { name, language, category, components = [] } = apiTemplate;

  const template = {
    name,
    language,
    category,
    header: 'NONE',
    headerText: '',
    headerMediaFile: null,
    headerMediaUrl: '',
    body: '',
    footer: '',
    buttons: [],
    format: 'STANDARD',
    cards: [],
    authCodeDeliveryMethod: 'COPY_CODE',
    addSecurityRecommendation: false,
    addExpirationTime: false,
    expirationTimeMinutes: null,
    packageName: '',
    signatureHash: '',
  };

  const sampleValues = {
    bodyValues: {},
    headerValues: {},
    buttonsValues: {},
  };

  components.forEach(component => {
    switch (component.type) {
      case 'HEADER':
        template.header = component.format;
        if (component.format === 'TEXT') {
          template.headerText = component.text;
          if (component.example?.header_text?.[0]) {
            sampleValues.headerValues[1] = component.example.header_text[0];
          }
        } else if (['IMAGE', 'VIDEO', 'DOCUMENT'].includes(component.format)) {
          template.headerMediaUrl = component.example?.header_url?.[0] || '';
        }
        break;

      case 'BODY':
        template.body = component.text || '';
        if (category === 'AUTHENTICATION') {
          template.addSecurityRecommendation =
            !!component.add_security_recommendation;
        }
        if (component.example?.body_text?.[0]) {
          component.example.body_text[0].forEach((val, index) => {
            sampleValues.bodyValues[index + 1] = val;
          });
        }
        break;

      case 'FOOTER':
        if (
          category === 'AUTHENTICATION' &&
          component.code_expiration_minutes
        ) {
          template.addExpirationTime = true;
          template.expirationTimeMinutes = component.code_expiration_minutes;
        } else {
          template.footer = component.text || '';
        }
        break;

      case 'BUTTONS':
      case 'buttons':
        if (category === 'AUTHENTICATION') {
          const otpButton = component.buttons?.[0];
          if (otpButton) {
            template.authCodeDeliveryMethod =
              otpButton.otp_type?.toUpperCase() || 'COPY_CODE';
            template.packageName = otpButton.package_name || '';
            template.signatureHash = otpButton.signature_hash || '';
            if (otpButton.otp_type === 'copy_code' && otpButton.example) {
              sampleValues.buttonsValues.COPY_CODE = otpButton.example;
            }
          }
        } else {
          template.buttons = (component.buttons || []).map(button => ({
            type: button.type,
            text: button.text,
            url: button.url,
            phone_number: button.phone_number,
            example: button.example,
          }));
        }
        break;

      case 'CAROUSEL':
        template.format = 'CAROUSEL';
        template.cards = (component.cards || []).map(card => {
          const parsedCard = {
            headerType: 'NONE',
            mediaUrl: '',
            body: '',
            buttons: [],
          };

          card.components.forEach(cardComp => {
            if (cardComp.type === 'HEADER') {
              parsedCard.headerType = cardComp.format;
              parsedCard.mediaUrl = cardComp.example?.header_url?.[0] || '';
            } else if (cardComp.type === 'BODY') {
              parsedCard.body = cardComp.text || '';
            } else if (
              cardComp.type === 'BUTTONS' ||
              cardComp.type === 'buttons'
            ) {
              parsedCard.buttons = (cardComp.buttons || []).map(b => ({
                type: b.type,
                text: b.text,
                url: b.url,
                phone_number: b.phone_number,
              }));
            }
          });
          return parsedCard;
        });
        break;

      default:
        break;
    }
  });

  return { template, sampleValues };
};
